import { cn } from '@repo/ui/lib/utils'
import { VariantProps } from 'class-variance-authority'
import { badgeVariants } from './variants'

type BadgeProps = {
  as?: React.ElementType
} & React.ComponentPropsWithoutRef<React.ElementType> &
  VariantProps<typeof badgeVariants>

export function Badge(props: BadgeProps) {
  const { tone, inverted, border, className, ...rest } = props

  const Component = props.as || 'div'

  return (
    <Component className={cn(badgeVariants({ tone, inverted, border }), className)} {...rest} />
  )
}
